import * as React from "react";

export class RenewalDocumentsBanner extends React.Component<{}> {

    public render() {
        return (
            <div className="banner renewal-document-banner banner-info">
                <div className="banner-text">
                    Heads up - <b> please read your <span className="link-style">document of insurance</span> along with your <span className="link-style">renewal invitation</span></b>
                </div>
            </div>
        );
    }
}
